import { useState } from 'react';

import { mockTabs } from 'external-quote/constants';

import { Tab, TabsContainer } from './styles';

export const TabNavigation = () => {
  const [activeTab, setActiveTab] = useState('List of Materials');

  return (
    <TabsContainer>
      {mockTabs.map((tab) => (
        <Tab key={tab} active={tab === activeTab} onClick={() => setActiveTab(tab)}>
          {tab}
        </Tab>
      ))}
    </TabsContainer>
  );
};
